<template>
  <ya-site-resource-list resource="order" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteOrderList',
  components: { YaSiteResourceList },
}
</script>
